"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EventDispatcher = _interopRequireDefault(require("./EventDispatcher"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class RaftInterface extends _EventDispatcher.default {
  // setIsModal(isModal: boolean) {
  //     if (isModal !== this.isModal) {
  //       this.isModal = isModal;
  //       this.dispatchEvent({
  //         type: "onIsModalChange",
  //         isModal: this.isModal,
  //       });
  //     }
  //   }

  unsubscribeFromPublishedData() {
    // will be implemented in the child class
  }
}
exports.default = RaftInterface;